import Image from 'next/image';
import {
  MecProduct,
  isPrimaryProductImage,
} from '@adapters/bigcommerce/types/product';
import Tag from '_components/UI/Tag';
import { normalizeImageVariantPreference } from 'utils/imageVariantPreference';

import styles from '../ProductCompareTable.module.scss';

interface ProductColumnProps {
  product: MecProduct;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  ariaLabel?: string;
  isFirst?: boolean;
}

const ProductColumn = ({
  product,
  href,
  onClick,
  ariaLabel,
  isFirst,
}: ProductColumnProps) => {
  const tags = (product.productTags?.filter((tag) => tag !== null) ?? []).slice(
    0,
    1
  );

  const priImages = (product.images ?? []).filter(isPrimaryProductImage);
  const preferredImage = normalizeImageVariantPreference(priImages, {
    preferTransparent: true,
  })[0];

  const media = preferredImage?.urlOriginal ? (
    <Image
      src={preferredImage.urlOriginal}
      alt={product.name}
      fill
      objectFit="contain"
      className={`${styles.productImage} ${
        isFirst ? styles.firstProductImage : ''
      }`}
    />
  ) : (
    <div className={styles.imagePlaceholder} aria-hidden="true" />
  );

  return (
    <div>
      <div
        className={`${styles.imageWrapper} ${
          isFirst ? styles.firstImageWrapper : ''
        }`}
      >
        {href ? (
          <a
            href={href}
            onClick={onClick}
            className={styles.imageLink}
            aria-label={ariaLabel}
          >
            {media}
          </a>
        ) : (
          media
        )}
        {tags.length > 0 && (
          <div className={styles.imageTag} aria-hidden="true">
            {tags.map((tag) => (
              <Tag key={tag!.name} size="medium" color="gray">
                {tag!.name}
              </Tag>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductColumn;
